export enum ConfirmAction {
    PrintAllDonorCertificates = 1,
    PrintAllVoucherCertificates = 2,
    DonorAction = 3,
    VoucherHolderAction = 4
}